import { create } from 'zustand';

import { computeSunTimes } from '../getSun';

// Coordinate dell'area impianti (Ancona). Servono solo a stimare giorno / notte.
const { sunrise, sunset } = computeSunTimes(new Date(), 43.6, 13.5);

const useSun = create((set) => ({
    sunrise,
    sunset,
    setSunrise: (sunrise) => set((state) => ({ ...state, sunrise })),
    setSunset: (sunset) => set((state) => ({ ...state, sunset })),
}));

export default useSun;
